"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNoMoreRewardModal = void 0;
const displayModal_1 = __importDefault(require("root/src/client/logic/modal/actions/displayModal"));
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const displayNoMoreRewardModal = ({ formData }) => (dispatch) => {
    dispatch((0, displayModal_1.default)(moduleIds_1.NO_MORE_REWARD_MODAL_MODULE_ID, { formData }));
};
exports.displayNoMoreRewardModal = displayNoMoreRewardModal;
